import { ABodySize } from '../../atoms/ABody';
import { AIconProps, AIconSize } from '../../atoms/AIcon/AIcon.types';
import React from 'react';

export enum MListNavState {
  Default = 'Default',
}
export enum MListNavType {
  Link = 'Link',
}

export type MListNavProps = {
  text: string;
  textSize: ABodySize;
  arrow?: boolean;
  arrowIcon?: string;
  type?: MListNavType;
  aIcon?: AIconProps;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  state?: MListNavState;
  ctaLink: string;
  size?: AIconSize;
};
